<template>
  <!--    <div v-if="isShown">-->
  <!--      &lt;!&ndash; 抽奖结果 &ndash;&gt;-->
  <!--      <div class="pop7" style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 999;">-->
  <!--        <div class="zd"></div>-->
  <!--        <a href="javascript:void 0;" @click="close" class="close pa db">关闭</a>-->
  <!--        <p class="pop7_tit1">温馨提示</p>-->
  <!--        <p class="pop7_tit2">关注【腾讯充值】公众号，订阅活动消息提醒</p>-->
  <!--        <div style="width: 200px;-->
  <!--        height: 200px;-->
  <!--  background: #fffdf1;-->
  <!--  margin: auto;-->
  <!--  margin-top: .36rem;-->
  <!--  overflow: hidden;">-->
  <!--          <img v-if="accountType=='wechat'" src="../../../../ui/a20191128charge/ossweb-img/txcz_scan.jpg" alt="">-->
  <!--          <img v-else-if="accountType=='qq'" src="../../../../ui/20190114/img/qrcode_qq.jpg" alt="">-->
  <!--        </div>-->
  <!--        <p class="pop7_tit3" v-if="userAgent.msdk">-->
  <!--          <span v-if="accountType=='wechat'">截图后请在微信环境中识别二维码</span>-->
  <!--          <span v-if="accountType=='qq'">截图后请在QQ环境中扫描二维码</span>-->
  <!--        </p>-->
  <!--        <p class="pop7_tit3" v-else-if="userAgent.QQ">扫描二维码，关注即订阅成功</p>-->
  <!--        <p class="pop7_tit3" v-else-if="userAgent.weixin">长按识别二维码，关注即订阅成功</p>-->
  <!--      </div>-->

  <!--      <div-->
  <!--        style="background-color: rgb(17, 17, 17); border-top: 1px solid rgb(17, 17, 17); position: absolute; z-index: 998; width: 100%; left: 0px; top: 0px; opacity: 0.7; display: block;" :style="{height:maskHeight+'px'}"></div>-->

  <!--    </div>-->
  <div class="Dialog tips attention" v-if="isShown">
    <div class="inner">
      <i class="close" @click="close"></i>
      <div class="title">关注公众号</div>
      <p class="description">关注「腾讯充值公众号」接收提醒，一起组队领大奖！</p>
      <img class="code-img" v-if="accountType=='wechat' || userAgent.weixin" src="../../../../ui/a20191128charge/ossweb-img/txcz_scan.jpg"
           alt="">
      <img class="code-img" v-else-if="accountType=='qq'" src="../../../../ui/20190114/img/qrcode_qq.jpg" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "FollowDialog",
  props: ["isShown"],
  data() {
    return {
      maskHeight: ""
    }
  },
  computed: {
    ...mapState(["accountType", "userAgent"])
  },
  mounted() {
    this.maskHeight = document.documentElement.scrollHeight
  },
  methods: {
    close() {
      this.$emit("update:isShown", false)
    }
  }
}
</script>

<style scoped>
</style>
